<template>
  <div class="animated fadeIn">
    <b-modal
      size="md"
      @close="hideModal"
      ref="modal-confirmacao-vincular"
      scrollable
      centered
      hide-header-close
      no-close-on-backdrop
    >
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Atenção
      </template>
      <p class="warn__subtitle">
        Este CPF/CNPJ já está cadastrado para:
        <br /><br />
        <strong>Nome:</strong> {{ (pessoaExistente && pessoaExistente.nomeAssociado) || (pessoaExistente && pessoaExistente.nome) || 'Não informado' }}
        <br />
        <strong>CPF/CNPJ:</strong> {{ (pessoaExistente && pessoaExistente.document) || 'Não informado' }}
        <br /><br />
        Deseja vincular esta visita ao usuário existente?
        <br /><br />
        ⚠️ O registro temporário atual será removido.
      </p>
      <template #modal-footer>
        <div
          style="gap: 0.5rem"
          class="d-flex align-end"
        >
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-danger"
            :onClick="onCancelar"
            text="Cancelar"
          />
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-third"
            :onClick="onConfirmar"
            text="Continuar"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'ConfirmacaoVincularPessoaModal',
  components: {
    DefaultButton
  },
  data () {
    return {
      pessoaExistente: null,
      isLoading: false,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  methods: {
    showModal (pessoaExistente) {
      if (!pessoaExistente) {
        throw new Error('Dados da pessoa existente são obrigatórios')
      }

      return new Promise((resolve, reject) => {
        this.pessoaExistente = {
          nomeAssociado: pessoaExistente.nomeAssociado || pessoaExistente.nome || 'Não informado',
          document: pessoaExistente.document || 'Não informado',
          ...pessoaExistente
        }

        this.$nextTick(() => {
          if (this.$refs['modal-confirmacao-vincular']) {
            this.$refs['modal-confirmacao-vincular'].show()
            this.resolvePromise = resolve
            this.rejectPromise = reject
          } else {
            reject(new Error('Modal não está disponível'))
          }
        })
      })
    },

    hideModal () {
      try {
        this.$refs['modal-confirmacao-vincular'].hide()
      } catch (error) {
        console.error('Erro ao esconder modal:', error)
      }
    },

    onConfirmar () {
      if (this.resolvePromise) {
        this.resolvePromise(true)
      }
      this.hideModal()
    },

    onCancelar () {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hideModal()
    }
  }
}
</script>

<style lang="scss">
.warn {
  &__subtitle {
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/confirmation/ConfirmacaoVincularPessoaModal.vue